import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import DashboardIcon from '@material-ui/icons/Dashboard';
import { appsMonitorApi } from './api';
import { appsMonitorRouteRef } from './routes';

const appsMonitorPage = PageBlueprint.make({
  params: {
    path: '/apps-monitor',
    routeRef: appsMonitorRouteRef,
    title: 'Apps Monitor',
    icon: <DashboardIcon fontSize="inherit" />,
    loader: () =>
      import('./components/AppsMonitorPage').then(m => <m.AppsMonitorPage />),
  },
});

export const appsMonitorPlugin = createFrontendPlugin({
  pluginId: 'apps-monitor',
  routes: { root: appsMonitorRouteRef },
  extensions: [appsMonitorPage, appsMonitorApi],
});

export default appsMonitorPlugin;
